// @flow

import styled from 'styled-components';
import getPosition from '../helpers/position';
import getTemplate from '../helpers/template';
import getThemeVariant from '../helpers/themeVariant';
import type { Theme } from '../../../types';
import type { WysiwygTemplates } from '../../../types/theme';

type Props = {
  template: $Keys<WysiwygTemplates>,
  position?: ?string,
  theme_variant?: ?string,
};

const Wrapper = styled<any, Theme, Props>('article')`
  display: flex;
  flex-direction: column;

  ${props => props.position && getPosition(props.position)}
  ${props => props.theme_variant && getThemeVariant(props.theme_variant, props.theme)}
  ${props => getTemplate(props.template, props.theme)}

  p {
    margin: 1rem 0;
  }

  img {
    max-width: 100%;
  }
`;

export default Wrapper;
